const grupoFamiliarInitialState = {
    grupoFamiliar: {
        loading: false,
        error: null,
        data: null,
        familiar: {
            loading: false,
            error: false,
            data: {},
        },
        tiposParentesco: {
            loading: false,
            error: false,
            data: {}
        },
        postFamiliar: {
            loading: false,
            error: false,
            data: false,
        },
        putFamiliar: {
            loading: false,
            error: false,
            data:false,
        },
        deleteFamiliar: {
            loading: false,
            error: false,
            data:false,
        },
        postFamiliarClave : {
            loading: false,
            error: false,
            data: false,
        }, 
        editarDerechos: {
            loading: false, 
            error: false, 
        }
    },
};

export default grupoFamiliarInitialState;